import React from 'react';
import styled from 'astroturf/react';

import { Icon } from 'js/design_system/Icon';
import _MenuItemContainer from "MenuItem-MenuItemContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/MenuItem.tsx?styleId=MenuItemContainer";


const MenuItemContainer = /*#__PURE__*/styled("button", null, {
  displayName: "MenuItemContainer",
  styles: _MenuItemContainer
});

export const MenuItem: React.FC<{
  className?: string;
  icon?: string | React.ReactNode;
  children?: React.ReactNode;
  onClick?: () => void;
}> = ({ className, icon, children, onClick }) => {
  let iconView = null;
  if (icon) {
    iconView = typeof icon === 'string' ? <Icon name={icon} /> : icon;
  }

  return (
    <MenuItemContainer className={className} onClick={onClick}>
      {iconView}
      {children}
    </MenuItemContainer>
  );
};
